import "./yieldsData.css";
import { DataGrid } from "@material-ui/data-grid";
import { DeleteOutline } from "@material-ui/icons";
import { apiUrl } from "../../config";
import { productRows } from "../../dummyData";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import alasql from "alasql";
//import Chart from '../../components/chart/Chart'
import {
  AreaChart,
  Area,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function YieldsData() {
  const [defiData, setDefiData] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [statsData, setStatsData] = useState([]);
  const [vaults, setVaults] = useState([]);

  useEffect(() => {
    const getDefiData = async () => {
      try {
        const res = await axios.get(apiUrl, {
          /*headers: {
            token:
            "Bearer "+JSON.parse(localStorage.getItem("user")).accessToken,
          },*/
        });
        let vaultByAssetId = [];
        let dataByAssetId = [];
        let dataByDt = [];
        let dataShort = res.data.map((item) => {
          item.Wallet =
            item.Wallet.substr(0, 4) +
            "..." +
            item.Wallet.substr(item.Wallet.length - 4);

          if (typeof dataByAssetId[item.assetId] === "undefined")
            dataByAssetId[item.assetId] = [];
          dataByAssetId[item.assetId].push({
            Datetime: item.Datetime,
            Balance: item.Balance,
            Reward: item.Reward,
            RewardToken: item.RewardToken,
          });

          let dt = new Date(item.Datetime);
          dt.setSeconds(0); //может быть разброс в несколько секунд от 02 до 04, сводим это все в 0, ошибка на 3 часах: 3*60*60=10800; 1/10800 ~ 0.01%
          var dtStr = dt
            .toString()
            .replace(
              /^[^\s]+\s([^\s]+)\s([^\s]+)\s([^\s]+)\s([^\s]+)\s.*$/gi,
              "$3-$1-$2 $4"
            );
          //console.log(dt, dtStr)
          if (typeof dataByDt[dtStr] === "undefined") {
            dataByDt[dtStr] = [];
            dataByDt[dtStr].push({ Dt: dtStr, Datetime: item.Datetime });
          }
          dataByDt[dtStr][item.assetId] = {
            Balance: item.Balance,
            Reward: item.Reward,
            RewardToken: item.RewardToken,
          };

          return item;
          //console.log(item.Wallet)
        });

        /*console.log(
          dataByAssetId,
          dataByDt,
          typeof dataByDt,
          Object.values(dataByDt)
        );*/

        //console.log('defiData=', res.data);

        let stats = alasql(
          "SELECT assetId, COUNT(*) AS cnt, min(Datetime) AS minDt, max(Datetime) AS maxDt, SUM(Balance) AS sumBal, max(Balance) AS maxBal, min(Balance) AS minBal, SUM(Reward) AS sumRwd, max(Reward) AS maxRwd, min(Reward) AS minRwd FROM ? WHERE Balance<>0 GROUP BY assetId",
          [dataShort]
        );
        //var d = [ {a: 1, b: 10}, {a: 2, b: 20}, {a: 1, b: 30} ];
        //var r = alasql('SELECT a, SUM(b) AS b FROM ? GROUP BY a',[d]);
        stats = AddId(stats);
        stats = AddStats(stats);
        console.log(stats);

        let vaultsL = alasql(
          "SELECT DISTINCT assetId, Wallet, Blockchain, Platform, Vault FROM ?",
          [dataShort]
        );
        console.log("vaultsL=", vaultsL);

        setDefiData(dataShort); //res.data
        setGraphData(Object.values(dataByDt));
        setStatsData(stats);
        setVaults(vaultsL);
      } catch (err) {
        console.log(err);
      }
    };
    getDefiData();
  }, []);

  const AddId = (data) => {
    let i = 0;
    let r = data.map((row) => {
      return { id: i++, ...row };
    });
    return r;
  };

  function DaysBetween(date1, date2) {
    // The number of milliseconds in one day
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date1 - date2);
    //console.log(date1, date2, differenceMs)

    // Convert back to days and return
    let r = differenceMs / oneDay;
    return +r.toFixed(2);
  }

  const AddStats = (data) => {
    let i = 0;
    let r = data.map((row) => {
      let daysBetw = DaysBetween(new Date(row.maxDt), new Date(row.minDt));
      return {
        daysBetween: daysBetw,
        balDelta: row.maxBal - row.minBal,
        balGrowth: row.maxBal / row.minBal,
        balAprDaily: ((row.maxBal / row.minBal - 1) / daysBetw) * 100,
        balApr: ((row.maxBal / row.minBal - 1) / daysBetw) * 100 * 365,
        rwdDelta: row.maxRwd - row.minRwd,
        rwdGrowth: row.maxRwd / row.minRwd,
        rwdAprDaily: ((row.maxRwd / row.minRwd - 1) / daysBetw) * 100,
        rwdApr: ((row.maxRwd / row.minRwd - 1) / daysBetw) * 100 * 365,
        ...row,
      };
    });
    return r;
  };

  const handleDelete = (id) => {
    //setData(data.filter((item) => item.id !== id));
  };

  const defiColumns = [
    { field: "Datetime", headerName: "Datetime", width: 180 },
    { field: "assetId", headerName: "Asset Id", width: 60 },
    { field: "Wallet", headerName: "Wallet", width: 120 },
    /*{
      field: "product",
      headerName: "Product",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="productListItem">
            <img className="productListImg" src={params.row.img} alt="" />
            {params.row.name}
          </div>
        );
      },
    },*/
    { field: "Blockchain", headerName: "Blockchain", width: 180 },
    {
      field: "Platform",
      headerName: "Platform",
      //type: "number",
      //width: 110,
      //editable: true,
    },
    {
      field: "Vault",
      headerName: "Vault",
      //description: "This column has a value getter and is not sortable.",
      //sortable: false,
      width: 140,
      /*valueGetter: (params) =>
                `${params.getValue(params.id, 'firstName') || ''} ${params.getValue(params.id, 'lastName') || ''
                }`,*/
    },
    { field: "Balance", headerName: "Balance", width: 200 },
    { field: "Reward", headerName: "Rewards", width: 200 },
    { field: "RewardToken", headerName: "Rewards Tokens", width: 200 },
    /*{
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <Link to={"/product/" + params.row.id}>
              <button className="productListEdit">Edit</button>
            </Link>
            <DeleteOutline
              className="productListDelete"
              onClick={() => handleDelete(params.row.id)}
            />
          </>
        );
      },
    },*/
  ];

  const colorScale = (v) => {
    return v >= 50
      ? "colorScale50"
      : v >= 30
      ? "colorScale30"
      : v >= 20
      ? "colorScale20"
      : v >= 10
      ? "colorScale10"
      : v >= 5
      ? "colorScale5"
      : v == 0
      ? "colorScale0"
      : "colorScaleDefault";
  };

  const statsColumns = [
    //{ field: "assetId", headerName: "Asset Id", width: 60 },
    /*{
      field: "assetId", 
      headerName: "Vault",
      valueGetter: (params) => {
        //return params.row.assetId
        let a = vaults.filter( el => el.assetId == params.row.assetId ); 
        console.log('a=',a);
        return params.row.assetId + a[0].Platform + a[0].Vault;
      },
      width: 160,
    },*/
    {
      field: "assetId",
      headerName: "Vault",
      renderCell: (params) => {
        //return params.row.assetId
        let a = vaults.filter((el) => el.assetId == params.row.assetId);
        //console.log('a=',a);
        return (
          <div className="tdVault">
            <span className="vaultPlatf">
              {params.row.assetId}. {a[0].Platform}, {a[0].Wallet}
            </span>
            <span className="vaultVlt">{a[0].Vault}</span>
          </div>
        );
      },
      width: 160,
    },
    {
      field: "balApr",
      headerName: "balAPR",
      renderCell: (params) => {
        return (
          <div className="tdVault">
            <span className="vaultPlatf">
              {params.row.balAprDaily.toFixed(4)} ({params.row.daysBetween})
            </span>
            <span className={"vaultVlt " + colorScale(params.row.balApr)}>
              {params.row.balApr.toFixed(1)}
            </span>
          </div>
        );
      },
      width: 140,
    },
    {
      field: "rwdApr",
      headerName: "rwdAPR",
      renderCell: (params) => {
        return (
          <div className="tdVault">
            <span className="vaultPlatf">
              {params.row.rwdAprDaily.toFixed(4)} ({params.row.daysBetween})
            </span>
            <span className={"vaultVlt " + colorScale(params.row.rwdApr)}>
              {params.row.rwdApr.toFixed(1)}
            </span>
          </div>
        );
      },
      width: 140,
    },
    { field: "minDt", headerName: "minDt", width: 160 },
    { field: "maxDt", headerName: "maxDt", width: 160 },
    { field: "minBal", headerName: "minBal", width: 160 },
    { field: "maxBal", headerName: "maxBal", width: 160 },
    { field: "minRwd", headerName: "minRwd", width: 80 },
    { field: "maxRwd", headerName: "maxRwd", width: 160 },
    { field: "cnt", headerName: "Count", width: 100 },
  ];

  //var data1=[{ ttt: {'ttl':'a'}, asd: 12 }, { ttt: {'ttl':'b'}, asd: 32 }, { ttt: {'ttl':'c'}, asd: 55 },]
  //var getVal1 = (x)=>{return x['asd'];}
  //var getName1 = (x)=>{return x.ttt.ttl;}

  var getName = (x) => {
    return x[0]["Dt"];
  };
  var getVal1 = (x) => {
    return typeof x[1] === "undefined" ? 0 : x[1]["Balance"];
  };
  var getVal2 = (x) => {
    return typeof x[2] === "undefined" ? 0 : x[2]["Balance"];
  };
  var getVal3 = (x) => {
    return typeof x[3] === "undefined" ? 0 : x[3]["Balance"];
  };
  var getVal4 = (x) => {
    return typeof x[4] === "undefined" ? 0 : x[4]["Balance"];
  };
  var getVal5 = (x) => {
    return typeof x[5] === "undefined" ? 0 : x[5]["Balance"];
  };
  var getVal6 = (x) => {
    return typeof x[6] === "undefined" ? 0 : x[6]["Balance"];
  };
  var getVal7 = (x) => {
    return typeof x[7] === "undefined" ? 0 : x[7]["Balance"];
  };
  var getVal8 = (x) => {
    return typeof x[8] === "undefined" ? 0 : x[8]["Balance"];
  };
  var getVal9 = (x) => {
    return typeof x[9] === "undefined" ? 0 : x[9]["Balance"];
  };
  var getVal10 = (x) => {
    return typeof x[10] === "undefined" ? 0 : x[10]["Balance"];
  };
  //console.log('gD:', graphData)

  return (
    <div className="yieldsData">
      <h1>Yields Data</h1>

      <DataGrid
        rows={defiData}
        columns={defiColumns}
        pageSize={25}
        checkboxSelection
        disableSelectionOnClick
      />
    </div>
  );
}
